import type TableView from "../store/schema/TableView";

/**
 * @param tableView for which we want to get the server folder id
 * @note client has code that default serverFolderId (which stores searchFolderId returned by server) to folderId,
 * and so serverFolderId may end up being identical as folderId. In the case that they're equal,
 * caller may want to treat it as if serverFolderId is not available.
 */
export default function getServerFolderId(tableView: TableView): string | undefined {
    if (tableView.serverFolderId === tableView.tableQuery.folderId) {
        return undefined;
    }
    
    return tableView.serverFolderId;
}
